const max = 10; // TODO: not using this, but maybe maximum notifications that can be displayed at one time?

const statuses = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info',
};

const statusList = Object.values(statuses);

export { statusList, statuses, max };
